import React from "react";
import { UserCheck, Clock, ShieldCheck, ClipboardCheck } from "lucide-react";

const items = [
  { Icon: UserCheck, title: "Nurse-led team", desc: "Founded by nurses from Manipal Hospitals." },
  { Icon: Clock, title: "Available 24 / 7", desc: "Day, night, Sundays — we pick up." },
  { Icon: ShieldCheck, title: "Hygiene & infection control", desc: "Sterile technique, single-use supplies." },
  { Icon: ClipboardCheck, title: "Personalised care plans", desc: "A plan built around your family." },
];

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" className="bg-mint py-10 md:py-12 border-y border-navy/5">
      <div className="container-x grid grid-cols-2 lg:grid-cols-4 gap-6">
        {items.map((it, i) => (
          <div key={i} className="flex items-start gap-3">
            <span className="icon-tile shrink-0 bg-white"><it.Icon className="w-6 h-6" /></span>
            <div>
              <div className="font-bold text-navy">{it.title}</div>
              <div className="text-[14.5px] text-ink/80 leading-snug">{it.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
